<script setup lang="ts">
interface Props {
  name: string
  icon: string
  label: string
}

defineProps<Props>()

defineOptions({
  name: 'BottomNavItem'
})
</script>

<template>
  <RouterLink :to="{ name }" active-class="active" class="bottom-nav_item">
    <VIcon :icon class="bottom-nav_item-icon" size="1.5rem" />
    <span class="bottom-nav_item-label">{{ label }}</span>
  </RouterLink>
</template>
